import { render } from "./FiscalAffordabilityTab.vue?vue&type=template&id=c1bfc47a&scoped=true"
import script from "./FiscalAffordabilityTab.vue?vue&type=script&lang=js"
export * from "./FiscalAffordabilityTab.vue?vue&type=script&lang=js"

import "./FiscalAffordabilityTab.vue?vue&type=style&index=0&id=c1bfc47a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1bfc47a"]])

export default __exports__